var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuestSolid = function SvgGuestSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.25c-1.259 0-2.32.846-2.647 2H7A2.75 2.75 0 0 0 4.25 7v12A2.75 2.75 0 0 0 7 21.75h10c1.044 0 1.77-.452 2.209-1.062a2.982 2.982 0 0 0 .54-1.688V7A2.75 2.75 0 0 0 17 4.25h-1.353a2.751 2.751 0 0 0-2.646-2h-2ZM9.75 5c0-.69.56-1.25 1.25-1.25h2a1.25 1.25 0 0 1 0 2.5h-2c-.69 0-1.25-.56-1.25-1.25ZM8.5 20.25h7V18.5a3 3 0 0 0-3-3h-1a3 3 0 0 0-3 3v1.75Zm6-8.25a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z",
    fill: "currentColor"
  })));
};
export default SvgGuestSolid;